import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-647ce7e8")

_pushScopeId("data-v-647ce7e8")
const _hoisted_1 = { class: "passenger-inf" }
const _hoisted_2 = { class: "left-part" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "title" }, "乘机人", -1)
const _hoisted_4 = { class: "addPassenger" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "hint" }, " 最多添加4位乘机人 ", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "separator" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "title" }, "联系人", -1)
const _hoisted_8 = { class: "clause" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 阅读并已同意 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("《购票须知》")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_passenger_info_box = _resolveComponent("passenger-info-box")
  const _component_contact_box = _resolveComponent("contact-box")
  const _component_router_link = _resolveComponent("router-link")
  const _component_fixed_box = _resolveComponent("fixed-box")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_passenger_info_box, {
        number: 1,
        identity: _ctx.identity1,
        "onUpdate:identity": _cache[1] || (_cache[1] = ($event: any) => (_ctx.identity1 = $event)),
        onAddInsurance: _ctx.addInsurance,
        onDiscardInsurance: _ctx.discardInsurance,
        onIsAdult: _ctx.isAdult,
        onIsChild: _ctx.isChild,
        ref: "passenger1"
      }, null, 8, ["identity", "onAddInsurance", "onDiscardInsurance", "onIsAdult", "onIsChild"]),
      (_ctx.count >= 2)
        ? (_openBlock(), _createBlock(_component_passenger_info_box, {
            key: 0,
            number: 2,
            identity: _ctx.identity2,
            "onUpdate:identity": _cache[2] || (_cache[2] = ($event: any) => (_ctx.identity2 = $event)),
            onAddInsurance: _ctx.addInsurance,
            onDiscardInsurance: _ctx.discardInsurance,
            onIsAdult: _ctx.isAdult,
            onIsChild: _ctx.isChild,
            ref: "passenger2"
          }, null, 8, ["identity", "onAddInsurance", "onDiscardInsurance", "onIsAdult", "onIsChild"]))
        : _createCommentVNode("", true),
      (_ctx.count >= 3)
        ? (_openBlock(), _createBlock(_component_passenger_info_box, {
            key: 1,
            number: 3,
            identity: _ctx.identity3,
            "onUpdate:identity": _cache[3] || (_cache[3] = ($event: any) => (_ctx.identity3 = $event)),
            onAddInsurance: _ctx.addInsurance,
            onDiscardInsurance: _ctx.discardInsurance,
            onIsAdult: _ctx.isAdult,
            onIsChild: _ctx.isChild,
            ref: "passenger3"
          }, null, 8, ["identity", "onAddInsurance", "onDiscardInsurance", "onIsAdult", "onIsChild"]))
        : _createCommentVNode("", true),
      (_ctx.count >= 4)
        ? (_openBlock(), _createBlock(_component_passenger_info_box, {
            key: 2,
            number: 4,
            identity: _ctx.identity4,
            "onUpdate:identity": _cache[4] || (_cache[4] = ($event: any) => (_ctx.identity4 = $event)),
            onAddInsurance: _ctx.addInsurance,
            onDiscardInsurance: _ctx.discardInsurance,
            onIsAdult: _ctx.isAdult,
            onIsChild: _ctx.isChild,
            ref: "passenger4"
          }, null, 8, ["identity", "onAddInsurance", "onDiscardInsurance", "onIsAdult", "onIsChild"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", null, [
          _createVNode("input", {
            class: "blue",
            type: "button",
            value: "添加一位乘机人",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addPassenger && _ctx.addPassenger(...args)))
          }),
          _hoisted_6,
          _createVNode("input", {
            class: "yellow",
            type: "button",
            value: "减少一位乘机人",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.discardPassenger && _ctx.discardPassenger(...args)))
          })
        ])
      ]),
      _hoisted_7,
      _createVNode(_component_contact_box, { ref: "contact" }, null, 512),
      _createVNode("div", _hoisted_8, [
        _createVNode("input", {
          type: "checkbox",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.changeIsRead && _ctx.changeIsRead(...args)))
        }),
        _hoisted_9,
        _createVNode(_component_router_link, {
          to: "/guide/passenger",
          target: "_blank"
        }, {
          default: _withId(() => [
            _hoisted_10
          ]),
          _: 1
        })
      ]),
      _createVNode("input", {
        type: "button",
        value: "确认信息，下一步",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)))
      })
    ]),
    _createVNode(_component_fixed_box, {
      adultAmount: _ctx.adultAmount,
      childAmount: _ctx.childAmount,
      insuranceTotalPrice: _ctx.insuranceTotalPrice,
      ref: "fixedBox"
    }, null, 8, ["adultAmount", "childAmount", "insuranceTotalPrice"])
  ]))
})